var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import ChartBase from './Chart.base';
/** @see IProps&lt;T = DataSeries&gt; extends IPropsChart|IProps&lt;DataSeries&gt; */
/** @see DataSeries */
var BarChart = function (props) { return React.createElement(ChartBase, __assign({}, props)); };
BarChart.defaultProps = {
    __TYPE: 'BarChart',
};
export default BarChart;
